import { ThreadMessageModel } from '@/lib/models/thread/thread-message.model';
import { createContext } from 'react';

export type EmitterEventType = 'stream-error';

export type EmitterEventData = {
  'stream-error': { message: ThreadMessageModel };
};

export type EmitterListener = <T extends EmitterEventType>(data?: EmitterEventData[T]) => void;

export interface EmitterSettings {
  subscribe: <T extends EmitterEventType>(types: T | T[], listenerFn: EmitterListener) => void;
  unsubscribe: <T extends EmitterEventType>(types: T | T[], listenerFn: EmitterListener) => void;
  emit: <T extends EmitterEventType>(type: T, data?: EmitterEventData[T]) => void;
}

export const EmitterContext = createContext<EmitterSettings>({
  subscribe: () => null,
  unsubscribe: () => null,
  emit: () => null,
});
